import { useDragLayer } from 'react-dnd';

var getStyle = function getStyle(currentOffset,collectedProps,props={}) {
	var diff = {
		x: collectedProps.initial.x - collectedProps.source.x,
		y: collectedProps.initial.y - collectedProps.source.y,
	}
	
	let offsetTop = props.height != undefined ? -(props.height) / 2 : 0;
	let offsetLeft = props.width != undefined ? -(props.width) / 2 : 0;

	var transform = "translate(".concat(currentOffset.x+diff.x, "px, ").concat(currentOffset.y+diff.y, "px)");
	return {
		pointerEvents: 'none',
		position: 'fixed',
		top: `${offsetTop}px`,
		left: `${offsetLeft}px`,
		transform: transform,
		WebkitTransform: transform
	};
};

var usePreview = function usePreview(props) {
	var collectedProps = useDragLayer(function (monitor) {
		return {
			currentOffset: monitor.getSourceClientOffset(),
			isDragging: monitor.isDragging(),
			itemType: monitor.getItemType(),
			item: monitor.getItem(),
			initial: monitor.getInitialClientOffset(),
			source:monitor.getInitialSourceClientOffset()
		};
	});

	if (!collectedProps.isDragging || collectedProps.currentOffset === null) {
		return {
			display: false
		};
	}

	return {
		display: true,
		itemType: collectedProps.itemType,
		item: collectedProps.item,
		style: getStyle(collectedProps.currentOffset,collectedProps,props)
	};
};

export { usePreview };